import React, { useState } from "react";
import "./MyAccount.scss";
import { Box } from "@mui/material";
import TabLine from "../../../components/Admin Panel/TabLine/TabLine";
import Tab from "../../../components/Admin Panel/Tab/Tab";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AccountSettings from "../AccountSettings/AccountSettings";
import ProfileSettings from "../ProfileSettings/ProfileSettings";
import { Integrations } from "../Integrations/Integrations";
import {IntegrationsOld} from "../Integrations/IntegrationsOld";

const MyAccount = ({ showGlobalSnackbar }) => {
  const app = useSelector((state) => state.app);
  const { t, i18n } = useTranslation();
  const [page, setPage] = useState(0);

  return (
    <div className="MyAccount">
      <Box className={"tabContainer"}>
        <Tab
          text={i18n.t("accountSettings")}
          isActive={page === 0}
          page={0}
          setPage={setPage}
        />
        <Tab
          text={i18n.t("profileSettings")}
          isActive={page === 1}
          page={1}
          setPage={setPage}
        />
        <Tab
          text={i18n.t("Integrations")}
          isActive={page === 2}
          page={2}
          setPage={setPage}
        />
      </Box>
      <Box className={"tabLineContainer"}>
        <TabLine total={3} step={page} app={app} />
      </Box>

      {page === 0 && (
        <AccountSettings
          showGlobalSnackbar={showGlobalSnackbar}
          app={app}
          i18n={i18n}
        />
      )}
      {page === 1 && (
        <ProfileSettings
          showGlobalSnackbar={showGlobalSnackbar}
          app={app}
          i18n={i18n}
        />
      )}
      {page === 2 && (
        <Integrations
          showGlobalSnackbar={showGlobalSnackbar}
          app={app}
          i18n={i18n}
        />
      )}
    </div>
  );
};

export default MyAccount;
